'use strict';

var moment = require('moment-timezone');

var Duration = {
  make: function make() {
    if (arguments.length == 2) { // (hours, minutes)
      return (arguments[0] * 60 * 60) + (arguments[1] * 60);
    } else if (arguments.length == 3) { // (hours, minutes, seconds)
      return (arguments[0] * 60 * 60) + (arguments[1] * 60) + arguments[2];
    } else {
      throw new TypeError('Duration#make expects arguments like (hours, minutes[, seconds])');
    }
  },

  format: function format(value) {
    return moment.duration(value, "seconds").humanize();
  },

  formatJSON: function formatJSON(duration) {
    if (typeof(duration) == 'number' && !isNaN(duration)) {
      return moment.utc(duration * 1000).format('H:mm');
    } else {
      return null;
    }
  },

  parseJSON: function parseJSON(durationString) {
    try {
      var parts = durationString.split(':');
      var hours = parseInt(parts[0]);
      var minutes = parseInt(parts[1]);
      var result = (hours * 60 * 60) + (minutes * 60);
      return (isNaN(result)) ? null : result;
    } catch(e) {
      return null;
    }
  }
};

module.exports = Duration;